import {extractColumnTable} from "src/modules/shared/data-transformer/utils";
import { stripHtml } from "src/modules/shared/utils/utils";
import {formatPriceWithoutDecimals} from "src/modules/shared/utils/priceUtils";

const convertRefundExampleResponseIntoTables = (data, format, numberOfLevel) => {
    console.debug('[RefundExampleDataTransformer]', 'convertRefundExampleResponseIntoTables')

    const refundExampleTables = []

    // Data n'est pas null ou undefined
    if(!data) {
        return {
                refundExampleTables
        }
    }   


    // pour chaque type de tableaux
    Object.keys(data).forEach(key => {
        const mainNode = data[key]
        const label = mainNode.libelle

        // on extrait les tableaux de valeurs en utilisant le premier et unique sous-noeud retourné
        const uniqueSubKey = Object.keys(mainNode.garanties)[0]
        const valuesNode = mainNode.garanties[uniqueSubKey]

        const { lines: refundExampleLines } = convertRefundExampleResponseNodeIntoLines(valuesNode)
        extractColumnTable(refundExampleTables, refundExampleLines, label, format, numberOfLevel, 'Reste à charge en niveau')
    });

    return {
        refundExampleTables
    }
}

/**
 * Converti une liste de donnée en ligne d'1 tableau
 * @param {*} node le noeud JSON à convertir
 * @returns un tableau de lines de tableau
 */
const convertRefundExampleResponseNodeIntoLines = (node) => {
    console.debug('[RefundExampleDataTransformer]', 'convertRefundExampleResponseNodeIntoLines', 'node', JSON.stringify(node))
    // on détermine le nombre de level max pour recréer les headers
    let maxLevel = 0
    const lines = []

    // Si node n'est pas null ou undefined
    if(!node) {
        return {
            maxLevel,
            lines
        }
    }

    Object.keys(node).forEach(key => {
        const mainNode = node[key]
        const cells = []

        // l'entête est extraite
        const cell = {
            label: mainNode.garantie,
            value: { moreInfo: stripHtml(mainNode.commentaire_1) }
        }
        cells.push(cell)

        // on transforme les niveaux en data
        const levelsNode = mainNode.niveaux
        let lastlevelKey = undefined
        Object.keys(levelsNode).forEach(key => {
            const line = {
                label: formatPriceWithoutDecimals(levelsNode[key].reste_a_charge),
                value: { level:key }
            }
            cells.push(line)
            lastlevelKey = key
        })

        lines.push(cells)

        if(maxLevel < parseInt(lastlevelKey)) {
            maxLevel = parseInt(lastlevelKey)
        }

    })

    return {
        maxLevel,
        lines
    }
}

export {
    convertRefundExampleResponseIntoTables
}
